import { Trophy } from "lucide-react";

/**
 * Top-10 brands a Vermittler has referred. Shows medals for #1-#3 and a
 * progress bar per brand by points.
 * Extracted from VermittlerDashboardPage.
 */
export default function TopBrands({ data }) {
    const items = (data?.items || []).slice(0, 10);
    const max = items[0]?.points || 1;
    const MEDAL = ["🥇", "🥈", "🥉"];
    return (
        <div className="bg-white border border-gray-200 rounded-sm p-6" data-testid="vermittler-top-brands">
            <div className="flex items-center gap-2 mb-1">
                <Trophy className="w-5 h-5 text-[#FFCC00]" />
                <h2 className="font-display font-bold text-lg">Top-Marken Bestenliste</h2>
            </div>
            <p className="text-xs text-gray-600 mb-4">
                Welche Fahrzeug-Marken Sie am häufigsten vermittelt haben — gerankt nach Punkten.
                {data?.total_referrals > 0 && (
                    <> Gesamt: <strong className="font-mono-num">{data.total_referrals}</strong> Vermittlungen · <strong className="font-mono-num">{data.total_points}</strong> Punkte.</>
                )}
            </p>
            {items.length === 0 ? (
                <div className="p-6 text-center text-sm text-gray-500 border border-dashed border-gray-200 rounded-sm" data-testid="top-brands-empty">
                    Noch keine Fahrzeug-Vermittlungen erfasst.
                </div>
            ) : (
                <ul className="space-y-2" data-testid="top-brands-list">
                    {items.map((b, i) => {
                        const pct = (b.points / max) * 100;
                        return (
                            <li key={b.brand} className="flex items-center gap-3" data-testid={`top-brand-${b.brand}`}>
                                <div className="w-8 text-center font-bold text-lg shrink-0">
                                    {MEDAL[i] || <span className="text-gray-400 text-xs font-mono-num">#{i + 1}</span>}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center justify-between mb-1">
                                        <div className="flex items-center gap-2 truncate">
                                            <span className="font-bold text-sm text-[#111827] truncate">{b.brand}</span>
                                            {b.category && (
                                                <span className="text-[10px] uppercase tracking-wider text-gray-400">
                                                    {b.category === "motorcycle" ? "Motorrad" : b.category === "bicycle" ? "Fahrrad" : b.category}
                                                </span>
                                            )}
                                        </div>
                                        <div className="text-xs font-mono-num font-bold text-[#111827] shrink-0">
                                            {b.count} × · <span className="text-[#FFCC00]">{b.points} P</span>
                                        </div>
                                    </div>
                                    <div className="h-1.5 bg-gray-100 rounded-sm overflow-hidden">
                                        <div className="h-full bg-[#FFCC00] transition-all" style={{ width: `${pct}%` }} />
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
